
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import DatePicker from '@/v2/discovery/DatePicker.vue';

export default defineComponent({
  name: 'SearchFilter',
  components: {
    DatePicker,
  },
  props: {
    totalStatistics: {
      type: Object as PropType<{
        total: number;
        totalGeneral: number;
        totalInvestment: number;
        totalComparision: number;
        totalInDepth: number;
      }>,
      required: true,
      default: () => ({
        total: 0,
        totalGeneral: 0,
        totalInvestment: 0,
        totalComparision: 0,
        totalInDepth: 0,
      }),
    },
  },
  emits: ['filterChange', 'changeLang', 'changeDate'],
  setup(props, { emit }) {
    const searchText = ref('');
    const selectedTab = ref('ALL');
    const language = ref<string>('all');

    // const tabs = computed(() => [
    //   { key: 'ALL', label: `All (${props.totalStatistics.total})` },
    //   { key: 'DAILY', label: `General  (${props.totalStatistics.totalGeneral})` },
    //   { key: 'INVESTMENT', label: `Investment  (${props.totalStatistics.totalInvestment})` },
    //   { key: 'COMPARISON', label: `Comparison  (${props.totalStatistics.totalComparision})` },
    //   { key: 'INDEPTH_REVIEW', label: `In-depth  (${props.totalStatistics.totalInDepth})` },
    // ]);

    const tabs = computed(() => [
      { key: 'ALL', label: getTabLabel('ALL', props.totalStatistics.total) },
      { key: 'DAILY', label: getTabLabel('DAILY', props.totalStatistics.totalGeneral) },
      { key: 'INVESTMENT', label: getTabLabel('INVESTMENT', props.totalStatistics.totalInvestment) },
      { key: 'COMPARISON', label: getTabLabel('COMPARISON', props.totalStatistics.totalComparision) },
      { key: 'INDEPTH_REVIEW', label: getTabLabel('INDEPTH_REVIEW', props.totalStatistics.totalInDepth) },
    ]);
    const getLang = (): string => {
      const userLang = localStorage.getItem('currentLanguage');
      if (typeof userLang === 'string') {
        return userLang;
      }

      switch (navigator.language) {
        case 'ko-KR':
        case 'ko':
          return 'ko';
        default:
          return 'en';
      }
    };

    const getTabLabel = (key: string, count: number): string => {
      const lang = getLang();
      const labelMap: Record<string, string> = {
        ALL: lang === 'en' ? 'All' : '전체',
        DAILY: lang === 'en' ? 'General' : '일반 리포트',
        INVESTMENT: lang === 'en' ? 'Investment' : '투자 리포트',
        COMPARISON: lang === 'en' ? 'Review' : '리뷰 리포트',
        INDEPTH_REVIEW: lang === 'en' ? 'In-depth' : '심층 리포트',
      };

      return `${labelMap[key] || ''} (${count})`;
    };
    const onFilterChange = () => {
      emit('filterChange', {
        tab: selectedTab.value,
        keyword: searchText.value,
      });
    };

    const selectTab = (tab: any) => {
      selectedTab.value = tab.key;
      onFilterChange();
    };

    const onChangeLang = (value: string) => {
      language.value = value;
      emit('changeLang', {
        lang: value,
      });
    };

    const languageLabel = computed(() => {
      switch (language.value) {
        case 'ko':
          return 'global.language.ko';
        case 'en':
          return 'global.language.en';
        case 'all':
        default:
          return 'global.language.all';
      }
    });

    const onChangeDate = (date: [string, string] | [null, null], type) => {
      const startDate = date[0];
      const endDate = date[1];
      emit('changeDate', {
        startDate: startDate,
        endDate: endDate,
      });
    };

    return {
      searchText,
      tabs,
      selectedTab,
      selectTab,
      onFilterChange,
      onChangeDate,
      onChangeLang,
      language,
      languageLabel,
      getLang,
      getTabLabel,
    };
  },
});
